import { render, staticRenderFns } from "./ImageCropper.vue?vue&type=template&id=36564e8d&scoped=true&"
import script from "./ImageCropper.vue?vue&type=script&lang=ts&"
export * from "./ImageCropper.vue?vue&type=script&lang=ts&"
import style0 from "./ImageCropper.vue?vue&type=style&index=0&id=36564e8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36564e8d",
  null
  
)

export default component.exports